<div class="not-found-layout">
  <header class="not-found-header w-full">
    <img src="assets/logo.svg" alt="Visera logo" class="logo main-logo" />
  </header>
  
  <main class="not-found-main">
    <div class="not-found-content">
      <h1>404</h1>
      <h2>{{ 'NOT_FOUND.TITLE' | translate }}</h2>
      <p>{{ 'NOT_FOUND.MESSAGE' | translate }}</p>
      <p-button
        [label]="'NOT_FOUND.GO_HOME' | translate"
        icon="pi pi-home"
        routerLink="/"
        styleClass="p-button-primary btn-primary">
      </p-button>
    </div>
  </main>
</div> 